module.exports = __webpack_public_path__ + "images/emoji/u6708.618bc3857640ad405521.png";